import {SeoMetadata} from "@next/utils"
import capitalizeFirstLetter from "../../capitalizeFirstLetter"

interface Placeholders {
    searchTerm: string
    filters: string
    market: string
    title?: string
}

export function replaceSeoMetadataPlaceholders(seoMetadata: SeoMetadata, placeholders: Placeholders) {
    const nextMetadata = {title: ""}
    const commaCheckedFilters =
        placeholders.filters && !placeholders.searchTerm
            ? placeholders.filters.replace(/, $/, "")
            : placeholders.filters
    Object.entries(seoMetadata || {}).forEach(([key, value]) => {
        nextMetadata[key] = value
            .replace(new RegExp("{SearchTerm}", "g"), placeholders.searchTerm)
            .replace(new RegExp("{Filters}", "g"), commaCheckedFilters)
            .replace(new RegExp("{CountryName}", "g"), placeholders.market)
            .replace(new RegExp("{Title}", "g"), placeholders.title)
            .replace(/ +(?= )/g, "")
    })
    nextMetadata.title = capitalizeFirstLetter(nextMetadata.title)
    return nextMetadata as SeoMetadata
}
